import clsx from 'clsx';
import {Field, ErrorMessage} from 'formik';
import TextError from './TextError';

function RadioButtons(props: any) {
  const {label, name, options, ...rest} = props;
  return (
    <>
      <label htmlFor={name} className={clsx('fw-bold fs-6 mb-2 me-4', {required: props.required})}>
        {label}
      </label>
      <Field name={name} {...rest}>
        {({field}: {field: any}) => {
          return options.map((option: any) => {
            return (
              <div key={option.key} className='form-check form-check-inline'>
                <input
                  className='form-check-input'
                  type='radio'
                  id={option.value}
                  {...field}
                  value={option.value}
                  checked={field.value === option.value}
                />
                <label htmlFor={option.value} className='form-check-label'>
                  {option.key}
                </label>
              </div>
            );
          });
        }}
      </Field>
      <ErrorMessage name={name} component={TextError} />
    </>
  );
}

export default RadioButtons;
